<template>
  <thead>
    <tr>
      <th scope="col">
        <span class='search-result-header'>ID</span>
        <a @click="changeSort('id')">
          <font-awesome-icon
          :class="getSortClass('id')"
          :icon="getSortIcon('id')"/>
        </a>
      </th>
      <th scope="col">
        <span class='search-result-header'>Property ID</span>
        <a @click="changeSort('propertyId')">
          <font-awesome-icon
          :class="getSortClass('propertyId')"
          :icon="getSortIcon('propertyId')"/>
        </a>
      </th>
      <th scope="col">
        <span class='search-result-header'>Category</span>
        <a @click="changeSort('serviceAgreementType')">
          <font-awesome-icon
          :class="getSortClass('serviceAgreementType')"
          :icon="getSortIcon('serviceAgreementType')"/>
        </a>
      </th>
      <th scope="col">
        <span class='search-result-header'>Component(s)</span>
      </th>
      <th scope="col">
        <span class='search-result-header'>Agreement Type</span>
        <a @click="changeSort('agreementTypeName')">
          <font-awesome-icon
          :class="getSortClass('agreementTypeName')"
          :icon="getSortIcon('agreementTypeName')"/>
        </a>
      </th>
      <th scope="col">
        <span class='search-result-header'>Status</span>
        <a @click="changeSort('serviceStatus')">
          <font-awesome-icon
          :class="getSortClass('serviceStatus')"
          :icon="getSortIcon('serviceStatus')"/>
        </a>
      </th>
      <th scope="col">
        <span class='search-result-header'>Staff Lead</span>
        <a @click="changeSort('staffLeadName')">
          <font-awesome-icon
          :class="getSortClass('staffLeadName')"
          :icon="getSortIcon('staffLeadName')"/>
        </a>
      </th>
      <th scope="col"></th>
    </tr>
  </thead>
</template>
<script>
export default {
  name: 'ServiceSearchResultHeader',
  props: {
    changeSort: {
      type: Function,
    },
    getSortClass: {
      type: Function,
    },
    getSortIcon: {
      type: Function,
    },
  },
};
</script>
